var _defs, _g, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKetoDiet(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 85 129",
    width: 24,
    height: 24,
    className: "ml-n5 mr-2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    filterUnits: "userSpaceOnUse",
    id: "Filter_nav_5",
    x: "1.5px",
    y: "1.5px",
    width: "82px",
    height: "126px"
  }, /*#__PURE__*/React.createElement("feOffset", {
    in: "SourceAlpha",
    dx: 0,
    dy: 7
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blurOut",
    stdDeviation: 0
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(0, 0, 0)",
    result: "floodOut"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "atop",
    in: "floodOut",
    in2: "blurOut"
  }), /*#__PURE__*/React.createElement("feComponentTransfer", null, /*#__PURE__*/React.createElement("feFuncA", {
    type: "linear",
    slope: 0.12
  })), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", null), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#Filter_nav_5)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    strokeWidth: "3px",
    stroke: "rgb(90, 115, 127)",
    fill: "rgb(190, 251, 149)",
    d: "M42.003,53.492 C50.571,53.492 59.496,70.004 59.496,77.901 C59.496,87.593 51.642,95.490 42.003,95.490 C32.364,95.490 24.511,87.593 24.511,77.901 C24.511,70.004 33.435,53.492 42.003,53.492 ZM5.500,83.799 C5.500,104.005 22.036,120.500 42.707,120.500 C62.964,120.500 79.500,104.005 79.500,83.799 C79.500,67.716 64.204,5.861 42.707,5.861 C21.209,5.861 5.500,67.716 5.500,83.799 Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    strokeWidth: "3px",
    stroke: "rgb(90, 115, 127)",
    fill: "rgb(255, 163, 96)",
    d: "M42.707,50.397 C52.628,50.397 62.964,69.366 62.964,78.438 C62.964,89.572 53.869,98.645 42.707,98.645 C31.545,98.645 22.450,89.572 22.450,78.438 C22.450,69.366 32.785,50.397 42.707,50.397 Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKetoDiet);
export default __webpack_public_path__ + "static/media/KetoDiet.0fff5d819aa5f6a910d79ca85ca61752.svg";
export { ForwardRef as ReactComponent };